import type { ProductState } from "@/core/products/components/ProductsTable";

export const toNumber = (value: number | string | undefined) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const resultingStock = (product: ProductState) =>
  toNumber(product.data.stock) + toNumber(product.amount);

export const findAdjustmentIssue = (products: ProductState[]) => {
  if (products.some((product) => toNumber(product.amount) === 0)) {
    return "Todas las cantidades deben ser distintas de 0.";
  }
  if (products.some((product) => resultingStock(product) < 0)) {
    return "Ningún producto puede quedar con stock bajo 0.";
  }
  return null;
};
